import { render, staticRenderFns } from "./Choise.vue?vue&type=template&id=1eb0bef1&scoped=true&"
import script from "./Choise.vue?vue&type=script&lang=js&"
export * from "./Choise.vue?vue&type=script&lang=js&"
import style0 from "./Choise.vue?vue&type=style&index=0&id=1eb0bef1&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.10.1_sqwtrzbl6s4ypz4dmnoirtpj7i/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eb0bef1",
  null
  
)

export default component.exports